module.exports = __webpack_public_path__ + "static/img/levietnga.bdde65b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/levietnga.png
// module id = tf4l
// module chunks = 1